<template lang="pug">
v-layout(align-start='')
  v-flex
    v-data-table.elevation-1(:headers='headers', :items='usuarios', :search='search', sort-by='nombre')
      template(v-slot:top='')
        v-toolbar(flat='', color='primary', dark='')
          v-toolbar-title Usuarios
          v-divider.mx-4(inset='', vertical='')
          v-spacer
          v-text-field.text-xs-center(v-model='search', label='Búsqueda', single-line='', hide-details='', color='success')
          v-spacer
          //Registro
          #Usuario
          v-dialog(v-model='dialog' scrollable persistent max-width='80%')
            template(v-slot:activator='{ on }')
              v-btn.mx-2(@click='abrir()', fab='', dark='', small='', color='success', v-on='on')
                v-icon(dark='') mdi-plus
            v-card(color='grey_1')
              v-app-bar(dark color='primary')
                v-toolbar-title.headline {{ formTitle }}
              v-card-text
                v-row(dense)
                  v-flex(xs12='xs12')
                    template
                      v-stepper(v-model='e6')
                        v-stepper-header
                          v-stepper-step( :complete="e6 > 1" step="1") Información
                          v-divider
                          v-stepper-step( :complete="e6 > 2" step="2") Permisos de Empresa
                          v-divider
                          v-stepper-step(step="3") Permisos Generales
                        v-stepper-items
                          v-stepper-content(step='1' color='grey_1')
                            v-col(cols='12')
                              v-card(color='white')
                                v-card-subtitle.title(style='color: black') Datos de Usuario
                                v-card-text
                                  v-row(dense)
                                    v-col(cols='12' md='4' v-if='editedIndex === -1')
                                      v-text-field(v-model='form.nombre', id="nombreReg", label='Nombre de Usuario', dense='', outlined)
                                    v-col(cols='12' md='4' v-else)
                                      v-text-field(v-model='form.nombre', id="nombreReg", label='Nombre de Usuario', dense='', outlined)
                                    v-col(cols='12' md='4' v-if='editedIndex === -1')
                                      v-text-field#correoUsuario(v-model='form.correo', label='Correo Usuario', dense='', outlined)
                                    v-col(cols='12' md='4' v-else)
                                      v-text-field#correoUsuario(v-model='form.correo', label='Correo Usuario', dense='', outlined)
                                    v-col(cols='12' md='4')
                                      v-text-field.input-group--focused(label='Contraseña', hint="La contraseña debe tener minimo 8 campos", dense='', outlined='', :append-icon="show3 ? 'visibility' : 'visibility_off'", :type="show3 ? 'text' : 'password'", v-model='form.contrasenna',  @click:append='show3 = !show3')
                            v-col(cols='12')
                              v-card(color='white')
                                v-card-subtitle.title(style='color: black') Datos de Empresa
                                v-card-text
                                  v-row(dense v-if='editedIndex === -1')
                                    v-col(cols='12' sm='12' md='6')
                                      v-autocomplete(
                                      autocomplete="off" v-model='form.nombreEmpresa', label='Empresa', dense='', outlined='', :items='idEmpresaArray',  multiple='multiple', hint='Seleccione la(s) empresa(s)')
                                    v-col(cols='12' sm='12' md='6')
                                      v-autocomplete(v-model='form.nombreEmpleado' :menu-props="{closeOnContentClick: true}" autocomplete="off" label='Empleado', dense='', outlined='', :items='idEmpleadoArray',  hint='Seleccione el empleado')
                                        template(v-slot:prepend-item)
                                          v-list(dense)
                                            v-list-item( @click='emp = true')
                                              v-list-item-avatar(color='grey_1')
                                                v-btn.mx-2(fab dark x-small color='success')
                                                  v-icon(dark small) mdi-plus
                                              v-list-item-content
                                                v-list-item-title
                                                  | Agregar Empleado
                                      EmpleadoM(:dialog='emp' :editedIndex='-1' @close='emp = false' @save='listarEmpleados')
                                  v-row(dense v-else)
                                    v-col(cols='12' sm='12' md='6')
                                      v-autocomplete(
                                      autocomplete="off",
                                      v-model='form.nombreEmpresa', id="empresaReg", label='Empresa', dense='', outlined='', :items='idEmpresaArray',  multiple='multiple', hint='Seleccione la(s) empresa(s)')
                                    v-col(cols='12' sm='12' md='6')
                                      v-autocomplete(
                                      autocomplete="off",
                                      v-model='form.nombreEmpleado', id="empleadoReg", label='Empleado', dense='', outlined='', :items='idEmpleadoArray',  hint='Seleccione el empleado',)
                            v-btn(color='success' small dark @click='validarSteps()')
                              span Continuar
                          v-stepper-content(step='2')
                            v-col(cols='12')
                              v-row(dense)
                                v-col(cols='12' md='12')
                                  span(v-if='form.nombreEmpleado && form.nombreEmpleado.tipo && form.nombreEmpleado.tipo.descripcion' style='display: flex;justify-content: center;font-size: 20px; color: black;') Tipo de Empleado: {{form.nombreEmpleado.tipo.descripcion}}
                                v-col(cols='12' md='12')
                                  v-data-table.elevation-4(:headers='headers3', dense, :items='form.nombreEmpresa', style='margin-top: 5px;')
                                    template(slot='items', slot-scope='props2')
                                      | {{ props2.item.nombre }}
                                    template(v-slot:item.action='{ item }')
                                      v-icon.mr-2(color='warning', @click='abrirmodal(item)') mdi-pencil
                              v-row(class='d-flex justify-center' dense)
                              v-dialog(v-model='dialog2' scrollable persistent max-width='800px')
                                v-card(color='grey_1')
                                  v-app-bar(dark color='primary')
                                    v-toolbar-title.headline Asociar Permisos
                                  v-card-text
                                    v-row(dense)
                                      v-col(cols='12')
                                        v-card(color='white')
                                          v-card-text
                                            v-row(dense)
                                              v-col(cols='12' md='6')
                                                v-autocomplete(
                                                autocomplete="off"
                                                v-model='accion', :items='options', label='Accion', dense='', outlined='', multiple='multiple', hint='Seleccione Acción')
                                              v-col(cols='12' md='6')
                                                v-autocomplete(
                                                  autocomplete="off"
                                                  v-model='ruta', :items='item', label='Ruta', dense='', outlined='', multiple='multiple', hint='Seleccione Categoria')
                                            v-row(class='d-flex justify-center' dense)
                                              v-col(cols='12' md='2')
                                                v-btn(color='success' dark @click='add(ruta,accion)') Agregar
                                      v-col(cols='12')
                                        v-card(color='white')
                                          v-card-subtitle.title(style='color: black') Permisos Asociados
                                          v-card-text
                                            v-row(dense)
                                              v-col(cols='12' md='1')
                                              v-col(cols='12' md='5')
                                                v-btn(color='error' small dark @click='DeleteAllPermisos()') Eliminar todos los permisos
                                              v-col(cols='12' md='1')
                                              v-col(cols='12' md='5')
                                                v-btn(color='success' small dark @click='AllPermisos()') Agregar todos los permisos
                                            v-row(dense)
                                              v-col(cols='12' md='12')
                                                v-data-table.elevation-1(:headers='headers2', dense, :items='listado', style='margin-top: 5px;')
                                                  template(slot='items', slot-scope='props2')
                                                  template(v-slot:item.action='{ item }')
                                                    v-icon(color='error' small='' @click='deleteItem2(item)')
                                                      | delete
                                  v-card-actions
                                    v-spacer
                                    v-btn(color='error' small dark @click='close2' class="mr-5")
                                      span Cancelar
                                    v-btn(color='success' small dark @click='guardar()')
                                      span Guardar
                            v-btn(color='error' small dark @click='e6 = 1, Selempresa= []' class="mr-5") Atras
                              v-spacer
                            v-btn(color='success' small dark @click='validarSteps()')
                              span Continuar
                          v-stepper-content(step='3')
                            v-col(cols='12')
                              v-card(color='white')
                                v-card-subtitle.title(style='color: black') Asociar Permisos
                                v-card-text
                                  v-row(dense)
                                    v-col(cols='12' md='6')
                                      v-autocomplete(
                                      autocomplete="off",
                                      v-model='accionG', :items='options', label='Accion', dense='', outlined='', multiple='multiple', hint='Seleccione Acción')
                                    v-col(cols='12' md='6')
                                      v-autocomplete(
                                      autocomplete="off"
                                      v-model='rutaG', :items='itemG', label='Ruta', dense='', outlined='', multiple='multiple', hint='Seleccione Categoria')
                                  v-row(class='d-flex justify-center' dense)
                                    v-col(cols='12' md='2')
                                      v-btn(color='success' small dark @click='addG(rutaG,accionG)') Agregar
                            v-col(cols='12')
                              v-card(color='white')
                                v-card-subtitle.title(style='color: black') Permisos Asociados
                                v-card-text
                                  v-row(dense)
                                    v-col(cols='12' md='1')
                                    v-col(cols='12' md='5')
                                        v-btn(color='error' dark small @click='DeleteAllPermisosG()') Eliminar todos los permisos
                                    v-col(cols='12' md='1')
                                    v-col(cols='12' md='5')
                                        v-btn(color='success' dark small @click='AllPermisosG()') Agregar todos los permisos
                                  v-row(dense)
                                    v-col(cols='12' md='12')
                                      v-data-table.elevation-4(:headers='headers2', dense, :items='listadoG', style='margin-top: 5px;')
                                        template(slot='items', slot-scope='props2')
                                        template(v-slot:item.action='{ item }')
                                          v-icon(color='error' small='' @click='deleteItem3(item)')
                                            | delete
                            v-col(cols='12')
                                v-row(class='d-flex justify-end' dense)
                                  v-btn(color='error' small dark @click='e6 = 2' class="mr-5")
                                    span Atras
                                  v-btn(color='success' small dark @click='save')
                                    v-icon mdi-content-save
                                    | Guardar
              v-card-actions
                v-spacer
                v-btn(color='error' small dark @click='close')
                  v-icon mdi-close
                  | Salir
          // View show
          v-dialog(v-model='dialogShow' scrollable persistent='', width='800')
            v-card(color='grey_1')
              v-app-bar(dark color='primary')
                span.headline Detalles del Usuario
              v-card-text
                v-row(dense)
                  v-col(cols='12')
                    v-card(color='white')
                      v-card-text
                        v-row(dense)
                          v-col(cols='12' md='4')
                            v-text-field(v-model='editedItem.nombre', readonly, label='Nombre de Usuario', dense='', outlined)
                          v-col(cols='12' md='4')
                            v-text-field#correo2(v-model='editedItem.correo', readonly, label='Correo Usuario', dense='', outlined)
                          v-col(cols='12' md='4')
                            v-text-field.input-group--focused(label='Contraseña', readonly, dense='', outlined='', :append-icon="show3 ? 'visibility' : 'visibility_off'", :type="show3 ? 'text' : 'password'", v-model='editedItem.contrasenna', @click:append='show3 = !show3')
                  v-col(cols='12')
                    v-card(color='white')
                      v-card-subtitle.title(style='color: black') Permisos por Empresa
                      v-card-text
                        v-flex(xs12 v-for='(item, i) in idEmpresaArray', :key='i')
                          v-row(dense)
                            v-col(cols='12' md='12')
                              v-text-field(v-model='item.nombre', label='Empresa', dense='', outlined='', readonly='' :items='idEmpresaArray', multiple='multiple', placeholder='Seleccione la(s) empresa(s)')
                          v-row(dense)
                            v-col(cols='12' md='12')
                              v-data-table.elevation-1(:headers='headers4', :items='item.permisos', style='margin-top: 5px;')
                                template(slot='items', slot-scope='props2')
                                  | {{ props2.item.ruta }}
                                  | {{ props2.item.accion }}
                  v-col(cols='12')
                    v-card(color='white')
                      v-card-subtitle.title(style='color: black') Permisos Generales
                        v-card-text
                          v-row(dense)
                              v-col(cols='12' md='12')
                                v-data-table.elevation-1(:headers='headers4', :items='listadoG', style='margin-top: 5px;')
                                  template(slot='items', slot-scope='props2')
                                    | {{ props2.itemG.rutaG }}
                                    | {{ props2.itemG.accionG }}
              v-card-actions
                v-spacer
                v-btn(color='error' small dark @click='close')
                  v-icon mdi-close
                  | Cancelar
          // View show
      template(v-slot:item.action='{ item }')
        v-tooltip(bottom='')
          template(v-slot:activator='{ on }')
            v-icon.mr-2(color='primary_2', @click='ShowItem(item)' v-on="on") mdi-eye
          | Visualizar
        v-tooltip(bottom='')
          template(v-slot:activator='{ on }')
            v-icon.mr-2(color='warning', @click='editItem(item)' v-on="on") mdi-pencil
          | Editar
        v-tooltip(bottom='')
          template(v-slot:activator='{ on }')
            v-icon(color='error', @click='deleteItem(item)' v-on="on") mdi-delete
          | Eliminar
</template>

<script>
import Api from '@/services/methods'
import EmpleadoM from '@/components/modals/EmpleadoM'
export default {
  data: () => ({
    emp: false,
    dialog: false,
    dialogShow: false,
    e6: 1,
    headers: [
      { text: 'Correo', value: 'correo', align: 'center' },
      { text: 'Usuario', value: 'nombre', align: 'center' },
      { text: 'Acciones', value: 'action', align: 'center', sortable: false }
    ],
    headers2: [
      { text: 'Ruta', value: 'ruta', align: 'center' },
      { text: 'Acciones', value: 'accion', align: 'center' },
      { text: 'Acción', value: 'action', align: 'center' }
    ],
    headers4: [
      { text: 'Ruta', value: 'ruta', align: 'center' },
      { text: 'Acciones', value: 'accion', align: 'center' }
    ],
    headers3: [
      { text: 'Empresas', value: 'nombre', align: 'center' },
      { text: 'Acción', value: 'action', align: 'center' }
    ],
    Selempresa: [],
    editedIndex: -1,
    show3: false,
    idEmpresaArray: [],
    idEmpleadoArray: [],
    dialogEdit: false,
    search: '',
    dialog2: false,
    usuarios: [],
    listado: [],
    listadoG: [],
    rutaG: '',
    accionG: '',
    ruta: '',
    master: '',
    accion: '',
    item2: ['Ajuste', 'AjustePrecio', 'Almacen', 'AnalisisVencimiento', 'Banco', 'Cliente', 'Compra', 'Concepto', 'Configuracion', 'CuentaPorCobrar', 'CuentaPorCobrarReporte', 'CuentaPorPagar', 'Cuenta', 'Departamento', 'Despacho', 'Empleado', 'Estado', 'EjecucionEstrategica', 'EjecucionPlanificacion', 'Fabricante', 'FacturaPedido', 'Importacion', 'IVA', 'Kardex', 'Linea', 'LiquidacionDespacho', 'ListadoProducto', 'Marca', 'Municipio', 'NotaCredito', 'NotaDebito', 'NotaEntrega', 'OrdenCompra', 'Pago', 'PagoFactura', 'Parroquia', 'Pedido', 'Perfil', 'Planificacion', 'Portafolio', 'PresentacionProd', 'Proalma', 'Producto', 'Proveedor', 'Ruta', 'Serial', 'TipoCliente', 'TipoEmpleado', 'TipoPago', 'TransferirAlmacen', 'UnidadVenta', 'Vehiculo', 'Vendedor', 'Venta', 'Zona', 'Soporte', 'OrdenesDeCotizacion', 'Serial'],
    item: ['Ajuste', 'AjustePrecio', 'Almacen', 'AnalisisVencimiento', 'Banco', 'Cliente', 'Compra', 'Concepto', 'Configuracion', 'CuentaPorCobrar', 'CuentaPorCobrarReporte', 'CuentaPorPagar', 'Cuenta', 'Departamento', 'Despacho', 'Empleado', 'Estado', 'EjecucionEstrategica', 'EjecucionPlanificacion', 'Fabricante', 'FacturaPedido', 'Importacion', 'IVA', 'Kardex', 'Linea', 'LiquidacionDespacho', 'ListadoProducto', 'Marca', 'Municipio', 'NotaCredito', 'NotaDebito', 'NotaEntrega', 'OrdenCompra', 'Pago', 'PagoFactura', 'Parroquia', 'Pedido', 'Perfil', 'Planificacion', 'Portafolio', 'PresentacionProd', 'Proalma', 'Producto', 'Proveedor', 'Ruta', 'Serial', 'TipoCliente', 'TipoEmpleado', 'TipoPago', 'TransferirAlmacen', 'UnidadVenta', 'Vehiculo', 'Vendedor', 'Venta', 'Zona', 'Soporte', 'OrdenesDeCotizacion', 'Serial'],
    itemres: [],
    item2G: ['Usuario', 'Empresa'],
    itemG: ['Usuario', 'Empresa'],
    empresaselec: {},
    options: ['Ver', 'Crear', 'Modificar', 'Eliminar'],
    Empresas: [],
    form: {
      nombre: '',
      correo: '',
      contrasenna: '',
      nombreEmpresa: [],
      nombreEmpleado: {}
    },
    editedItem: {
      nombre: '',
      correo: '',
      contrasenna: '',
      nombreEmpresa: [],
      nombreEmpleado: {}
    }
  }),
  components: {
    EmpleadoM
  },

  computed: {
    formTitle () {
      return this.editedIndex === -1
        ? 'Nuevo Usuario'
        : 'Modificar Usuario'
    }
  },

  watch: {
    dialog (val) {
      val || this.close()
    },
    dialog2 (val) {
      val || this.close2()
    },
    dialogShow (val) {
      val || this.close()
    }
  },
  created () {
    if (this.$store.state.usuario.master) {
      this.master = this.$store.state.usuario.master
    } else {
      this.master = this.$store.state.usuario._id
    }
    this.initialize()
  },
  methods: {
    listarEmpleados () {
      this.idEmpleadoArray = []
      Api.get('empleado')
        .then(response => {
          let empleados = response.data
          empleados.map(data => {
            this.idEmpleadoArray.push({
              text: data.nombre + ' ' + data.apellido,
              value: { id: data._id, tipo: data.tipoEmpleado }
            })
          })
        })
        .catch(e => {
          console.log('error' + e)
        })
    },

    deleteItem2 (item) {
      this.$swal
        .fire({
          title: '¿Estás seguro?',
          text: 'No podrás revertir esta operación!',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Si, Eliminar!'
        })
        .then(result => {
          if (result.value) {
            for (let i = 0; i < this.listado.length; i++) {
              if (this.listado[i].ruta === item.ruta) {
                this.listado.splice(i, 1)
                this.item.push(item.ruta)
              }
            }
            for (let i = 0; i < this.empresaselec.permisos.length; i++) {
              if (this.empresaselec.permisos[i].ruta === item.ruta) {
                this.empresaselec.permisos.splice(i, 1)
              }
            }
          }
        })
    },
    deleteItem3 (item) {
      this.$swal
        .fire({
          title: '¿Estás seguro?',
          text: 'No podrás revertir esta operación!',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Si, Eliminar!'
        })
        .then(result => {
          if (result.value) {
            for (let i = 0; i < this.listadoG.length; i++) {
              if (this.listadoG[i].ruta === item.ruta) {
                this.listadoG.splice(i, 1)
                this.itemG.push(item.ruta)
              }
            }
          }
        })
    },
    abrirmodal (data) {
      this.empresaselec = data
      this.listado = []
      for (let i = 0; i < data.permisos.length; i++) {
        this.listado.push(data.permisos[i])
      }
      this.item = ['Ajuste', 'AjustePrecio', 'Almacen', 'AnalisisVencimiento', 'Banco', 'Cliente', 'Compra', 'Concepto', 'Configuracion', 'CuentaPorCobrar', 'CuentaPorCobrarReporte', 'CuentaPorPagar', 'Cuenta', 'Departamento', 'Despacho', 'Empleado', 'Estado', 'EjecucionEstrategica', 'EjecucionPlanificacion', 'Fabricante', 'FacturaPedido', 'Importacion', 'IVA', 'Kardex', 'Linea', 'LiquidacionDespacho', 'ListadoProducto', 'Marca', 'Municipio', 'NotaCredito', 'NotaDebito', 'NotaEntrega', 'OrdenCompra', 'Pago', 'PagoFactura', 'Parroquia', 'Pedido', 'Perfil', 'Planificacion', 'Portafolio', 'PresentacionProd', 'Proalma', 'Producto', 'Proveedor', 'Ruta', 'Serial', 'TipoCliente', 'TipoEmpleado', 'TipoPago', 'TransferirAlmacen', 'UnidadVenta', 'Vehiculo', 'Vendedor', 'Venta', 'Zona', 'Soporte', 'OrdenesDeCotizacion', 'Serial']
      this.itemres = []
      for (let i = 0; i < this.form.nombreEmpresa.length; i++) {
        if (data.id === this.form.nombreEmpresa[i].id) {
          for (let j = 0; j < this.form.nombreEmpresa[i].permisos.length; j++) {
            for (let e = 0; e < this.item.length; e++) {
              if (this.form.nombreEmpresa[i].permisos[j].ruta === this.item[e]) {
                this.item.splice(e, 1)
                e = 0
              }
            }
          }
        }
      }
      for (let i = 0; i < this.item.length; i++) {
        this.itemres.push(this.item[i])
      }
      this.dialog2 = true
    },
    initialize () {
      if (this.$store.state.usuario.master) {
        this.master = this.$store.state.usuario.master
      } else {
        this.master = this.$store.state.usuario._id
      }
      this.dialog = false
      this.dialog2 = false
      this.form = Object.assign({}, this.editedItem)
      this.idEmpresaArray = []
      this.idEmpleadoArray = []
      this.form.nombreEmpresa = []
      this.form.nombreEmpleado = {}
      this.listado = []
      this.listadoG = []
      this.editedIndex = -1
      this.listarUsuario()
      this.item = ['Ajuste', 'AjustePrecio', 'Almacen', 'AnalisisVencimiento', 'Banco', 'Cliente', 'Compra', 'Concepto', 'Configuracion', 'CuentaPorCobrar', 'CuentaPorCobrarReporte', 'CuentaPorPagar', 'Cuenta', 'Departamento', 'Despacho', 'Empleado', 'Estado', 'EjecucionEstrategica', 'EjecucionPlanificacion', 'Fabricante', 'FacturaPedido', 'Importacion', 'IVA', 'Kardex', 'Linea', 'LiquidacionDespacho', 'ListadoProducto', 'Marca', 'Municipio', 'NotaCredito', 'NotaDebito', 'NotaEntrega', 'OrdenCompra', 'Pago', 'PagoFactura', 'Parroquia', 'Pedido', 'Perfil', 'Planificacion', 'Portafolio', 'PresentacionProd', 'Proalma', 'Producto', 'Proveedor', 'Ruta', 'Serial', 'TipoCliente', 'TipoEmpleado', 'TipoPago', 'TransferirAlmacen', 'UnidadVenta', 'Vehiculo', 'Vendedor', 'Venta', 'Zona', 'Soporte', 'OrdenesDeCotizacion', 'Serial']
      this.itemG = ['Usuario', 'Empresa']
    },
    guardar () {
      for (let i = 0; i < this.form.nombreEmpresa.length; i++) {
        if (this.empresaselec.id === this.form.nombreEmpresa[i].id) {
          this.form.nombreEmpresa[i].permisos = []
          for (let j = 0; j < this.listado.length; j++) {
            this.form.nombreEmpresa[i].permisos.push(this.listado[j])
          }
        }
      }
      this.dialog2 = false
    },
    close2 () {
      this.dialog2 = false
      this.listado = []
      this.item = []
      for (let i = 0; i < this.itemres.length; i++) {
        this.item.push(this.itemres[i])
      }
    },
    close () {
      this.Selempresa = []
      this.dialog = false
      this.dialogShow = false
      this.e6 = 1
      this.form = Object.assign({}, this.editedItem)
      this.idEmpresaArray = []
      this.idEmpleadoArray = []
      this.form.nombreEmpresa = []
      this.form.nombreEmpleado = {}
      this.dialogEdit = false
      this.listado = []
      this.listadoG = []
      this.editedIndex = -1
      this.item = ['Ajuste', 'AjustePrecio', 'Almacen', 'AnalisisVencimiento', 'Banco', 'Cliente', 'Compra', 'Concepto', 'Configuracion', 'CuentaPorCobrar', 'CuentaPorCobrarReporte', 'CuentaPorPagar', 'Cuenta', 'Departamento', 'Despacho', 'Empleado', 'Estado', 'EjecucionEstrategica', 'EjecucionPlanificacion', 'Fabricante', 'FacturaPedido', 'Importacion', 'IVA', 'Kardex', 'Linea', 'LiquidacionDespacho', 'ListadoProducto', 'Marca', 'Municipio', 'NotaCredito', 'NotaDebito', 'NotaEntrega', 'OrdenCompra', 'Pago', 'PagoFactura', 'Parroquia', 'Pedido', 'Perfil', 'Planificacion', 'Portafolio', 'PresentacionProd', 'Proalma', 'Producto', 'Proveedor', 'Ruta', 'Serial', 'TipoCliente', 'TipoEmpleado', 'TipoPago', 'TransferirAlmacen', 'UnidadVenta', 'Vehiculo', 'Vendedor', 'Venta', 'Zona', 'Soporte', 'OrdenesDeCotizacion', 'Serial']
      this.itemG = ['Usuario', 'Empresa']
    },
    validarContrasenna () {
      if (this.form.contrasenna.length < 8) {
        this.$swal({
          icon: 'error',
          title: 'Error!',
          text:
            'El campo de contraseña debe tener al menos 8 digitos, por favor verifique'
        })
        return true
      } else {
        return false
      }
    },
    validarCorreo () {
      const validate = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      if (!validate.test(this.form.correo)) {
        this.$swal({
          icon: 'error',
          title: 'Error!',
          text: 'El correo ingresado no cumple con el debido formato'
        })
        return true
      }
      return false
    },
    validarCampos () {
      if (
        this.form.nombre === '' ||
        this.form.contrasenna === '' ||
        this.form.correo === '' ||
        this.form.nombreEmpresa === '' ||
        this.listado === '' ||
        this.listadoG === ''
      ) {
        this.$swal({
          icon: 'error',
          title: 'Formulario incompleto',
          text: 'Por favor llene todos los campos para continuar'
        })
        return true
      }
      return false
    },
    validarSteps () {
      switch (this.e6) {
        case 1:
          if (this.form.nombreEmpleado.tipo && this.form.nombreEmpleado.tipo.permisos && this.form.nombreEmpresa.length > 0) {
            this.e6 = 2
            if (this.editedIndex === -1) {
              for (let i = 0; i < this.form.nombreEmpresa.length; i++) {
                this.form.nombreEmpresa[i].permisos = []
                for (let j = 0; j < this.form.nombreEmpleado.tipo.permisos.length; j++) {
                  this.form.nombreEmpresa[i].permisos.push(this.form.nombreEmpleado.tipo.permisos[j])
                }
              }
            } else {
              for (let i = 0; i < this.form.nombreEmpresa.length; i++) {
                if (this.form.nombreEmpresa[i].permisos.length === 0) {
                  for (let j = 0; j < this.form.nombreEmpleado.tipo.permisos.length; j++) {
                    this.form.nombreEmpresa[i].permisos.push(this.form.nombreEmpleado.tipo.permisos[j])
                  }
                }
              }
            }
          } else {
            this.$swal({
              icon: 'error',
              title: 'Error al continuar',
              text: 'Para continuar con el proceso debe seleccionar al menos una empresa y un empleado.'
            })
          }
          break
        case 2:
          this.e6 = 3
          break
        case 3:
      }
    },
    abrir () {
      this.dialog = true
      Api.get('/empresa/master/' + this.master).then((response) => {
        response.data.map(data => {
          this.idEmpresaArray.push({
            text: data.nombre,
            value: { id: data._id, nombre: data.nombre, permisos: [] }
          })
        })
      })
      Api.get('/empleado').then(response => {
        let empleados = response.data
        empleados.map(data => {
          this.idEmpleadoArray.push({
            text: data.nombre + ' ' + data.apellido,
            value: { id: data._id, tipo: data.tipoEmpleado }
          })
        })
      })
      // this.$store.state.empresa.map(data => {
      //   this.idEmpresaArray.push({
      //     text: data.nombre,
      //     value: { id: data.idEmpresa, nombre: data.nombre }
      //   })
      // })
      this.ruta = []
      this.accion = []
      this.form.permisosG = []
      this.editedItem.permisosG = []
      this.editedItem.permisos = []
      this.rutaG = []
      this.accionG = []
      this.form.nombre = ''
      this.form.contrasenna = ''
      this.form.correo = ''
      this.form.nombreEmpresa = []
    },
    listarUsuario () {
      Api.get('/usuario')
        .then(response => {
          this.usuarios = []
          for (let i = 0; i < response.data.length; i++) {
            if (response.data[i].master) {
              this.usuarios.push(response.data[i])
            }
          }
        })
        .catch(e => {
          console.log('error' + e)
        })
    },

    editItem (item) {
      this.editedIndex = this.usuarios.indexOf(item)
      this.form.nombre = item.nombre
      this.form.correo = item.correo
      this.form.contrasenna = item.contrasenna
      Api.get('/empresa/master/' + this.master).then((response) => {
        response.data.map(data => {
          this.idEmpresaArray.push({
            text: data.nombre,
            value: { id: data._id, nombre: data.nombre, permisos: [] }
          })
        })
        this.form.nombreEmpresa = []
        for (let i = 0; i < item.Empresa.length; i++) {
          this.form.nombreEmpresa.push({ id: item.Empresa[i].idEmpresa, nombre: item.Empresa[i].nombre, permisos: item.Empresa[i].permisos })
          for (let j = 0; j < this.idEmpresaArray.length; j++) {
            if (this.idEmpresaArray[j].value.id === item.Empresa[i].idEmpresa) {
              this.idEmpresaArray[j].value.permisos = item.Empresa[i].permisos
            }
          }
        }
      })
      Api.get('/empleado').then(response => {
        let empleados = response.data
        empleados.map(data => {
          this.idEmpleadoArray.push({
            text: data.nombre + ' ' + data.apellido,
            value: { id: data._id, tipo: data.tipoEmpleado }
          })
          if (data._id === item.idEmpleado) {
            this.form.nombreEmpleado = { id: data._id, tipo: data.tipoEmpleado }
          }
        })
      })
      this.dialog = true
      this.form._id = item._id
      this.listadoG = []
      this.form.permisosG = []
      for (let j = 0; j < item.permisos.length; j++) {
        for (let i = 0; i < this.itemG.length; i++) {
          if (item.permisos[j].ruta === this.itemG[i]) {
            this.itemG.splice(i, 1)
            i = 0
          }
        }
        this.listadoG.push({
          ruta: item.permisos[j].ruta,
          accion: item.permisos[j].accion
        })
        this.form.permisosG.push({
          ruta: item.permisos[j].ruta,
          accion: item.permisos[j].accion
        })
      }
    },
    ShowItem (item) {
      this.editedIndex = this.usuarios.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.listado = []
      this.listadoG = []
      for (let j = 0; j < item.permisos.length; j++) {
        this.listadoG.push({
          ruta: item.permisos[j].ruta,
          accion: item.permisos[j].accion
        })
      }
      for (let i = 0; i < item.Empresa.length; i++) {
        this.idEmpresaArray.push(item.Empresa[i])
        // this.idEmpresaArray.push(item.Empresa[i].nombre)
        // for (let j = 0; j < item.Empresa[i].permisos.length; j++) {
        //   this.listado.push({
        //     ruta: item.Empresa[i].permisos[j].ruta,
        //     accion: item.Empresa[i].permisos[j].accion
        //   })
        // }
      }
      this.editedItem.nombreEmpresa = this.idEmpresaArray
      this.dialogShow = true
    },
    deleteItem (item) {
      const index = this.usuarios.indexOf(item)
      this.$swal({
        icon: 'warning',
        title: '¿Seguro que quiere borrar?',
        text: 'No podrá revertir',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, borrar',
        cancelButtonText: 'cancelar'
      }).then(result => {
        if (result.value) {
          this.usuarios.splice(index, 1)
          Api.delete('/usuario/' + item._id).then(response => {
            this.$swal('Borrado!', 'Su registro fue borrado.', 'success')
          })
        }
      })
    },
    save () {
      this.form.master = this.master
      if (this.editedIndex > -1) {
        if (
          !this.validarCamposE() &&
          !this.validarContrasennaE() &&
          !this.validarCorreoE()
        ) {
          this.$swal({
            title: 'Cargando...',
            html: 'Esperando respuesta del servidor',
            allowOutsideClick: false,
            onBeforeOpen: () => { this.$swal.showLoading() }
          })
          Api.put('/usuario/oth', this.form)
            .then(res => {
              if (res.data.status === 'denied') {
                this.$swal({
                  icon: 'error',
                  title: 'Error al guardar',
                  text: res.data.message
                })
              } else {
                this.initialize()
                this.$swal({
                  icon: 'success',
                  title: 'Modificacion exitosa',
                  text: 'Todos los cambios han sido efectuados'
                })
                this.close()
              }
            })
            .catch(error => {
              if (error.response) {
                this.$swal({
                  icon: 'error',
                  title: 'Error al modificar',
                  text: 'Por favor, verifique los datos e intente de nuevo'
                })
              } else if (error.request) {
                this.$swal({
                  icon: 'error',
                  title: 'Error de red',
                  text: 'Por favor verique su conexion de internet'
                })
              } else {
                console.log('Error', error.message)
              }
            })
        }
      } else {
        if (
          !this.validarCampos() &&
          !this.validarContrasenna() &&
          !this.validarCorreo()
        ) {
          Api.post('usuario/oth', this.form)
            .then(res => {
              if (res.data.status === 'denied') {
                this.$swal({
                  icon: 'error',
                  title: 'Error al guardar',
                  text: res.data.message
                })
              } else {
                this.$swal({
                  icon: 'success',
                  title: 'Inclusion exitosa',
                  text: 'Todos los datos han sido guardados'
                })
                this.initialize()
                this.close()
              }
            })
            .catch(error => {
              if (error.response) {
                this.$swal({
                  icon: 'error',
                  title: 'Error al guardar',
                  text: 'Por favor, verifique los datos e intente de nuevo'
                })
              } else if (error.request) {
                this.$swal({
                  icon: 'error',
                  title: 'Error de red',
                  text: 'Por favor verique su conexion de internet'
                })
              } else {
                console.log('Error', error.message)
              }
            })
        }
      }
    },
    AllPermisosG () {
      this.rutaG = ''
      this.accionG = ''
      this.listadoG = []
      // this.editedItem.permisosG = [];
      this.form.permisosG = []
      for (let i = 0; i < this.item2G.length; i++) {
        this.listadoG.push({
          ruta: this.item2G[i],
          accion: 'Ver Crear Modificar Eliminar'
        })
        this.form.permisosG.push({
          ruta: this.item2G[i],
          accion: this.options
        })
        // this.editedItem.permisosG.push({ ruta: this.item2G[i], accion: this.options });
      }
      this.$swal('Felicidades.!', 'Permisos Agregados con Exito.', 'success')
      this.itemG = []
    },
    DeleteAllPermisosG () {
      this.rutaG = ''
      this.accionG = ''
      this.listadoG = []
      this.form.permisosG = []
      // this.editedItem.permisosG = [];
      this.itemG = []
      for (let i = 0; i < this.item2G.length; i++) {
        this.itemG.push(this.item2G[i])
      }
      this.$swal('Felicidades.!', 'Permisos Eliminados con Exito.', 'success')
    },
    addG (rutaG, accionG) {
      let bols = false
      let view = false
      if (rutaG && accionG) {
        for (let j = 0; j < accionG.length; j++) {
          if (accionG[j] === 'Ver') {
            view = true
          }
        }
        if (view === true) {
          if (this.form.permisosG.length > 0) {
            for (let i = 0; i < this.form.permisosG.length; i++) {
              for (let j = 0; j < rutaG.length; j++) {
                if (this.form.permisosG[i].rutaG === rutaG[j]) {
                  bols = true
                }
              }
            }
          }

          if (bols === false) {
            let stg = ''
            for (let e = 0; e < accionG.length; e++) {
              stg += accionG[e] + ' '
            }
            for (let i = 0; i < rutaG.length; i++) {
              this.listadoG.push({ ruta: rutaG[i], accion: stg })
              this.form.permisosG.push({ ruta: rutaG[i], accion: accionG })
              for (let j = 0; j < this.itemG.length; j++) {
                if (rutaG[i] === this.itemG[j]) {
                  this.itemG.splice(j, 1)
                }
              }
            }
            this.$swal(
              'Felicidades.!',
              'Permiso Agregado con Exito.',
              'success'
            )
            this.rutaG = ''
            this.accionG = ''
          } else {
            this.$swal(
              'Oops...',
              'Ya posee en la lista esta misma ruta, eliminela y vuelva a añadir si desea modificarla.',
              'error'
            )
          }
        } else {
          this.$swal(
            'Oops...',
            'Para agregar esta o estas acciones a la lista es necesario incluir la acción (VER) en la misma.',
            'error'
          )
        }
      } else {
        this.$swal(
          'Oops...',
          'Debe ingresar ambos campos( ruta y accion ) para poder agregarlo a la lista.',
          'error'
        )
      }
    },
    AllPermisos () {
      this.ruta = ''
      this.accion = ''
      this.listado = []
      // this.editedItem.permisos = [];
      for (let i = 0; i < this.item2.length; i++) {
        this.listado.push({
          ruta: this.item2[i],
          accion: 'Ver Crear Modificar Eliminar'
        })
        // this.editedItem.permisos.push({ ruta: this.item2[i], accion: this.options });
      }
      this.$swal('Felicidades.!', 'Permisos Agregados con Exito.', 'success')
      this.item = []
    },
    DeleteAllPermisos () {
      this.ruta = ''
      this.accion = ''
      this.listado = []
      // this.editedItem.permisos = [];
      this.item = []
      for (let i = 0; i < this.item2.length; i++) {
        this.item.push(this.item2[i])
      }
      this.$swal('Felicidades.!', 'Permisos Eliminados con Exito.', 'success')
    },
    add (ruta, accion) {
      let bols = false
      let view = false
      if (ruta && accion) {
        for (let j = 0; j < accion.length; j++) {
          if (accion[j] === 'Ver') {
            view = true
          }
        }
        if (view === true) {
          if (this.empresaselec.permisos.length > 0) {
            for (let i = 0; i < this.empresaselec.permisos.length; i++) {
              for (let j = 0; j < ruta.length; j++) {
                if (this.empresaselec.permisos[i].ruta === ruta[j]) {
                  bols = true
                }
              }
            }
          }

          if (bols === false) {
            let stg = ''
            for (let e = 0; e < accion.length; e++) {
              stg += accion[e] + ' '
            }
            for (let i = 0; i < ruta.length; i++) {
              this.listado.push({ ruta: ruta[i], accion: stg })
              for (let j = 0; j < this.item.length; j++) {
                if (ruta[i] === this.item[j]) {
                  this.item.splice(j, 1)
                }
              }
            }
            this.$swal(
              'Felicidades.!',
              'Permiso Agregado con Exito.',
              'success'
            )
            this.ruta = ''
            this.accion = ''
          } else {
            this.$swal(
              'Oops...',
              'Ya posee en la lista esta misma ruta, eliminela y vuelva a añadir si desea modificarla.',
              'error'
            )
          }
        } else {
          this.$swal(
            'Oops...',
            'Para agregar esta o estas acciones a la lista es necesario incluir la acción (VER) en la misma.',
            'error'
          )
        }
      } else {
        this.$swal(
          'Oops...',
          'Debe ingresar ambos campos( ruta y accion ) para poder agregarlo a la lista.',
          'error'
        )
      }
    },
    validarContrasennaE () {
      if (this.form.contrasenna.length < 8) {
        this.$swal({
          icon: 'error',
          title: 'Error!',
          text:
            'El campo de contraseña debe tener al menos 8 digitos, por favor verifique'
        })
        return true
      } else {
        return false
      }
    },
    validarCorreoE () {
      const validate = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      if (!validate.test(this.form.correo)) {
        this.$swal({
          icon: 'error',
          title: 'Error!',
          text: 'El correo ingresado no cumple con el debido formato'
        })
        return true
      }
      return false
    },
    validarCamposE () {
      if (
        this.form.nombre === '' ||
        this.form.contrasenna === '' ||
        this.form.correo === '' ||
        this.form.nombreEmpresa.length === 0 ||
        this.listadoG === ''
      ) {
        this.$swal({
          icon: 'error',
          title: 'Formulario incompleto',
          text: 'Por favor llene todos los campos para continuar'
        })
        return true
      }
      return false
    }
  }
}
</script>
<style lang='scss'>
@import '~@/assets/scss/regConPermisos.scss';
</style>
